import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Card, message } from "antd";
import UserService from "../../../Modules/Services/user.service.ts";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await UserService.login(values.username, values.password);
      message.success("Вход выполнен успешно!");
      navigate("/admin/dashboard");
    } catch (error) {
      message.error("Неверный логин или пароль.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card title="Вход в панель администратора" className="login-card">
        <Form name="login" onFinish={onFinish} layout="vertical">
          <Form.Item
            label="Имя пользователя"
            name="username"
            rules={[
              {
                required: true,
                message: "Пожалуйста, введите имя пользователя!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: "Пожалуйста, введите пароль!" }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Войти
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
